import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { SlotSpinner } from "./SlotSpinner";
import { toast } from "sonner";
import { usePerformance } from "@/contexts/PerformanceContext";

export const NumberGenerator = () => {
  const [min, setMin] = useState("1");
  const [max, setMax] = useState("100");
  const [showSpinner, setShowSpinner] = useState(false);
  const { lightModeEnabled } = usePerformance();

  const handleGenerate = () => {
    const minVal = parseInt(min);
    const maxVal = parseInt(max);

    if (isNaN(minVal) || isNaN(maxVal)) {
      toast.error("Please enter valid numbers");
      return;
    }

    if (minVal >= maxVal) {
      toast.error("Min must be less than Max");
      return;
    }

    if (maxVal - minVal + 1 > 1000) {
      toast.error("Range too large. Maximum 1000 numbers allowed.");
      return;
    }

    setShowSpinner(true);
  };

  return (
    <div className="w-full max-w-5xl mx-auto space-y-8">
      {!showSpinner && (
        <Card className={`p-8 space-y-6 ${!lightModeEnabled ? 'bg-gradient-to-br from-slate-900/95 via-slate-800/95 to-slate-900/95 backdrop-blur-sm' : 'bg-card'} border-2 border-primary/30 shadow-2xl`}>
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-3xl font-black bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent mb-2">
                Configure Your Draw
              </h2>
              <p className="text-muted-foreground">Set your number range and spin to win</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-lg mx-auto">
              <div className="space-y-2">
                <Label htmlFor="min" className="text-foreground font-semibold text-lg">
                  Minimum
                </Label>
                <Input
                  id="min"
                  type="number"
                  value={min}
                  onChange={(e) => setMin(e.target.value)}
                  placeholder="1"
                  className="bg-background/50 border-2 border-primary/30 focus:border-primary transition-all duration-300 h-12 text-lg"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="max" className="text-foreground font-semibold text-lg">
                  Maximum
                </Label>
                <Input
                  id="max"
                  type="number"
                  value={max}
                  onChange={(e) => setMax(e.target.value)}
                  placeholder="100"
                  className="bg-background/50 border-2 border-primary/30 focus:border-primary transition-all duration-300 h-12 text-lg"
                />
              </div>
            </div>

            <button
              onClick={handleGenerate}
              className="relative group w-full max-w-md mx-auto block py-4 rounded-xl bg-gradient-to-r from-primary via-accent to-primary hover:opacity-90 text-primary-foreground font-bold shadow-2xl transition-all duration-300 text-xl overflow-hidden touch-manipulation active:scale-[0.98]"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000" />
              <span className="relative">Start Lucky Draw</span>
            </button>
          </div>
        </Card>
      )}

      {showSpinner && (
        <SlotSpinner
          min={parseInt(min)}
          max={parseInt(max)}
          count={1}
        />
      )}
    </div>
  );
};